import { Link } from 'wouter';

export const ProjectLink = ({ name, projectId }: { name: string; projectId: number }) => (
  <Link
    to={`~/platform/directory/projects/${projectId}`}
    className='text-sm underline text-brand-500'
  >
    {name}
  </Link>
);
